/** Retro sun on the horizon + a sparse starfield. Cosmetic only. */
import * as THREE from 'three';
import { HORIZON_Z } from '../core/constants';
import { PALETTE } from './palette';

export class Background {
  readonly group = new THREE.Group();
  private sunMat: THREE.MeshBasicMaterial;
  private glowMat: THREE.MeshBasicMaterial;

  constructor() {
    // Sun.
    const sunGeo = new THREE.CircleGeometry(60, 48);
    this.sunMat = new THREE.MeshBasicMaterial({ color: PALETTE.accent, transparent: true, opacity: 0.9 });
    const sun = new THREE.Mesh(sunGeo, this.sunMat);
    sun.position.set(0, -10, HORIZON_Z - 20);
    this.group.add(sun);

    const glowGeo = new THREE.CircleGeometry(110, 48);
    this.glowMat = new THREE.MeshBasicMaterial({ color: PALETTE.secondary, transparent: true, opacity: 0.22 });
    const glow = new THREE.Mesh(glowGeo, this.glowMat);
    glow.position.set(0, -10, HORIZON_Z - 25);
    this.group.add(glow);

    // Stars.
    const starCount = 400;
    const arr = new Float32Array(starCount * 3);
    for (let i = 0; i < starCount; i++) {
      arr[i * 3] = (Math.random() - 0.5) * 500;
      arr[i * 3 + 1] = (Math.random() - 0.2) * 300;
      arr[i * 3 + 2] = HORIZON_Z + Math.random() * 120;
    }
    const starGeo = new THREE.BufferGeometry();
    starGeo.setAttribute('position', new THREE.BufferAttribute(arr, 3));
    const starMat = new THREE.PointsMaterial({ color: 0x8ea2ff, size: 1.4, transparent: true, opacity: 0.8 });
    this.group.add(new THREE.Points(starGeo, starMat));
  }

  /** Re-tint to the active sector palette. */
  retint(): void {
    this.sunMat.color.copy(PALETTE.accent);
    this.glowMat.color.copy(PALETTE.secondary);
  }
}
